import { useEffect, useRef } from 'react';
import { isFinite } from 'underscore';
import { ReadyState } from 'components/VideoPlayer/utils';
import { useEditSceneModalPlaybackContext } from '../EditSceneModalPlaybackContext';
import useFrameAccurateSeek from '../useFrameAccurateSeek';

export type UseSeekToClipOnMountProps = {
  playbackStartSec: number;
};

export default function useSeekToClipOnMount({
  playbackStartSec,
}: UseSeekToClipOnMountProps) {
  const { playerRef } = useEditSceneModalPlaybackContext();
  const videoEl = playerRef.current?.dangerousHTMLVideoElement;
  const seekToFrameAccurate = useFrameAccurateSeek();

  const initializedRef = useRef(false);

  useEffect(() => {
    const videoPlayer = playerRef.current;

    if (!videoPlayer) {
      return;
    }

    const seekToStart = async () => {
      if (!videoEl) {
        return;
      }

      try {
        await seekToFrameAccurate(playbackStartSec);
      } catch (error) {
        // fallback to normal seek
        videoPlayer.currentTime = playbackStartSec;
      }

      initializedRef.current = true;
      videoPlayer.removeEventListener('loadedmetadata', seekToStart);
    };

    if (
      isFinite(playbackStartSec) &&
      videoPlayer.readyState >= ReadyState.HAVE_METADATA &&
      !initializedRef.current
    ) {
      seekToStart();
    } else {
      videoPlayer.addEventListener('loadedmetadata', seekToStart);
    }
  }, [playbackStartSec, playerRef, seekToFrameAccurate, videoEl]);
}
